import { ISelectOption, ISelectPreset } from '~/src/dash/components/dropdowns/common';
import { TKey } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

export enum EDebugPrebidData {
  ShowAll = 0,
  NotLowPacing,
  SiteWeightEnabled,
}

export const DebugPrebidDataOptions: ISelectOption[] = [
  { id: 0, label: 'Show All', tKey: 'ShowAll' },
  { id: 1, label: 'Not Low Pacing', tKey: 'NotLowPacing' },
  { id: 2, label: 'Site Weight Enabled', tKey: 'SiteWeightEnabled' },
];

export enum ECampaignDeliveryStatus {
  Unknown = 0,
  Draft = 3,
  Untargeted,
  InvalidMediafile,
  Ready,
  Upcoming,
  Delivering,
  DeliveryGoalMet,
  Completed,
  Inactive,
}

export const TextStatusToEnum = (text: string): ECampaignDeliveryStatus => {
  switch (text) {
    case 'Draft':
      return ECampaignDeliveryStatus.Draft;
    case 'Untargeted':
      return ECampaignDeliveryStatus.Untargeted;
    case 'InvalidMediafile':
      return ECampaignDeliveryStatus.InvalidMediafile;
    case 'Ready':
      return ECampaignDeliveryStatus.Ready;
    case 'Upcoming':
      return ECampaignDeliveryStatus.Upcoming;
    case 'Delivering':
      return ECampaignDeliveryStatus.Delivering;
    case 'DeliveryGoalMet':
      return ECampaignDeliveryStatus.DeliveryGoalMet;
    case 'Completed':
      return ECampaignDeliveryStatus.Completed;
    case 'Inactive':
      return ECampaignDeliveryStatus.Inactive;
    default:
      return ECampaignDeliveryStatus.Unknown;
  }
};

export const CampaignStatusOptions: ISelectOption[] = [
  { id: ECampaignDeliveryStatus.Draft, label: 'Draft', tKey: 'Draft' },
  { id: ECampaignDeliveryStatus.Untargeted, label: 'Untargeted', tKey: 'Untargeted' },
  {
    id: ECampaignDeliveryStatus.InvalidMediafile,
    label: 'Invalid Mediafile',
    tKey: 'InvalidMediaFile',
  },
  { id: ECampaignDeliveryStatus.Ready, label: 'Ready', tKey: 'Ready' },
  { id: ECampaignDeliveryStatus.Upcoming, label: 'Upcoming', tKey: 'Upcoming' },
  { id: ECampaignDeliveryStatus.Delivering, label: 'Delivering', tKey: 'Delivering' },
  {
    id: ECampaignDeliveryStatus.DeliveryGoalMet,
    label: 'Delivery Goal Met',
    tKey: 'DeliveryGoalMet',
  },
  { id: ECampaignDeliveryStatus.Completed, label: 'Completed', tKey: 'Completed' },
  { id: ECampaignDeliveryStatus.Inactive, label: 'Inactive', tKey: 'Inactive' },
];

export const CampaignStatusPresets: ISelectPreset[] = [
  {
    label: 'Running',
    subset: new Set([ECampaignDeliveryStatus.Ready, ECampaignDeliveryStatus.Delivering]),
    tKey: 'Running',
  },
  {
    label: 'Not Running',
    subset: new Set([
      ECampaignDeliveryStatus.Draft,
      ECampaignDeliveryStatus.DeliveryGoalMet,
      ECampaignDeliveryStatus.Completed,
    ]),
    tKey: 'NotRunning',
  },
];

interface ISticker {
  color: string;
  backgroundColor: string;
  tKey: TKey;
  tooltipTKey: TKey;
}

export const ECampaignStatusToSticker = (status: ECampaignDeliveryStatus): ISticker => {
  switch (status) {
    case ECampaignDeliveryStatus.Draft:
      return {
        color: publicaColors.veryDarkGray,
        backgroundColor: publicaColors.veryLightGray,
        tKey: 'Draft',
        tooltipTKey: 'CampaignStatusTooltipDraft',
      };
    case ECampaignDeliveryStatus.Untargeted:
      return {
        color: publicaColors.veryDarkGray,
        backgroundColor: publicaColors.veryLightGray,
        tKey: 'Untargeted',
        tooltipTKey: 'CampaignStatusTooltipUntargeted',
      };
    case ECampaignDeliveryStatus.InvalidMediafile:
      return {
        color: publicaColors.veryDarkGray,
        backgroundColor: publicaColors.veryLightGray,
        tKey: 'InvalidMediaFile',
        tooltipTKey: 'CampaignStatusTooltipMediafileError',
      };
    case ECampaignDeliveryStatus.Ready:
      return {
        color: publicaColors.orange,
        backgroundColor: publicaColors.veryLightOrange,
        tKey: 'Ready',
        tooltipTKey: 'CampaignStatusTooltipReady',
      };
    case ECampaignDeliveryStatus.Upcoming:
      return {
        color: publicaColors.darkPurple,
        backgroundColor: publicaColors.lightLilac,
        tKey: 'Upcoming',
        tooltipTKey: 'CampaignStatusTooltipNotStartedYet',
      };
    case ECampaignDeliveryStatus.Delivering:
      return {
        color: publicaColors.jungleGreen,
        backgroundColor: publicaColors.honeydew,
        tKey: 'Delivering',
        tooltipTKey: 'CampaignStatusTooltipDelivering',
      };
    case ECampaignDeliveryStatus.DeliveryGoalMet:
      return {
        color: publicaColors.blue,
        backgroundColor: publicaColors.lighterBlue,
        tKey: 'DeliveryGoalMet',
        tooltipTKey: 'CampaignStatusTooltipGoalMet',
      };
    case ECampaignDeliveryStatus.Completed:
      return {
        color: publicaColors.blue,
        backgroundColor: publicaColors.lighterBlue,
        tKey: 'Completed',
        tooltipTKey: 'CampaignStatusTooltipCompleted',
      };
    case ECampaignDeliveryStatus.Inactive:
      return {
        color: publicaColors.veryDarkGray,
        backgroundColor: publicaColors.veryLightGray,
        tKey: 'Inactive',
        tooltipTKey: 'CampaignStatusTooltipInactive',
      };
    default:
      return {
        color: publicaColors.veryDarkGray,
        backgroundColor: publicaColors.veryLightGray,
        tKey: 'Unknown',
        tooltipTKey: '',
      };
  }
};
